import { Grid, Stack } from "@mui/material";
import React, { useEffect } from "react";
import CardInvestment from "./CardInvestment";

function ContainerCardsInvestment({ data, columns, childSizes }) {
  return (
    <Stack>
      <Grid container columns={columns} spacing={3}>
        {(data || []).map((element, index) => {
          return (
            <CardInvestment
              dataCard={element}
              key={index}
              sizeXS={childSizes.xs}
              sizeSM={childSizes.sm}
              sizeMD={childSizes.md}
              sizeLG={childSizes.lg}
            />
          );
        })}
      </Grid>
    </Stack>
  );
}

export default ContainerCardsInvestment;
